import { InterviewFilter } from "src/screens/Dashboard/webiner/hooks/useInterviewCandidate";
import { HR_BASE_URL } from "./appConst";
import { axiosAuth } from "./common";

export const getWebinarCandidates = async (filters: InterviewFilter) => {

  const { name, email, state, district, currentPageNumber, pageSize } = filters;

  const params = new URLSearchParams();

  params.set("page", currentPageNumber.toString());
  params.set("pageSize", pageSize.toString());

  if (name?.trim()) params.set("name", name.trim());
  if (email?.trim()) params.set("email", email.trim());
  if (state?.trim()) params.set("state", state.trim());
  if (district?.trim()) params.set("district", district.trim());

  const api = axiosAuth();

  const response = await api.get(`${HR_BASE_URL}/webminar/registrations?${params.toString()}`);

  return response.data.data.webminers;
};

export const deleteCandidate = async (ids: string[]) => {
  const api = axiosAuth(HR_BASE_URL);
  
  await api.delete(`/webminar/registration`, {
    data: {
      ids,
    },
  });
};
